import MainLayout from "../../components/layout/MainLayout"
import InventoryOverview from "./components/inventory-overview"

const InventoryIndex = () => {
    return (
        <MainLayout>
            <InventoryOverview />z
        </MainLayout>
    )
}

export default InventoryIndex